import React from 'react'

export default function Facebook({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path
        d="M39.8 12.2H48V0h-9.7C26.6.5 24.2 7.1 24 14v6.1h-8V32h8v32h12V32h9.9l1.9-11.9H36v-3.7a3.962 3.962 0 013.8-4.2z"
        fill="currentColor"
      />
    </svg>
  )
}
